const todosActionTypes = {
    SET_TODOS_ARRAY:'SET_TODOS_ARRAY',
    SET_TODOLIST:'SET_TODOLIST'
}

export default todosActionTypes